<template>
  <v-container>
    <v-row justify="center">
      <v-col lg="3">
        <h2>Archives</h2>
        <p></p>
        <h3>Meeting reports</h3>
        <p></p>

        <ul>
          <li>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://africanpollendatabase.ipsl.fr/media/PDFarchives/Bierville1996.pdf"
              >Bierville 1996</a
            >
          </li>
          <li>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://africanpollendatabase.ipsl.fr/media/PDFarchives/Johannesburg1997.pdf"
              >Johannesburg 1997</a
            >
          </li>
          <li>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://africanpollendatabase.ipsl.fr/media/PDFarchives/Kew1998.pdf"
              >Kew 1998</a
            >
          </li>
          <li>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://africanpollendatabase.ipsl.fr/media/PDFarchives/Durban1999.pdf"
              >Durban 1999</a
            >
          </li>
          <li>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://africanpollendatabase.ipsl.fr/media/PDFarchives/Toulouse1999.pdf"
              >Toulouse 1999</a
            >
          </li>
          <li>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://africanpollendatabase.ipsl.fr/media/PDFarchives/Nanjing%202000.pdf"
              >Nanjing 2000</a
            >
          </li>
          <li>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://africanpollendatabase.ipsl.fr/media/PDFarchives/Marseille%202001.pdf"
              >Marseille 2001</a
            >
          </li>
          <li>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://africanpollendatabase.ipsl.fr/media/PDFarchives/Nairobi%202001.pdf"
              >Nairobi 2001</a
            >
          </li>
          <li>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://africanpollendatabase.ipsl.fr/media/PDFarchives/Casablanca%202002.pdf"
              >Casablanca 2002</a
            >
          </li>
          <li>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://africanpollendatabase.ipsl.fr/media/PDFarchives/Bondy%202019.pdf"
              >Bondy 2019</a
            >
          </li>
        </ul>
      </v-col>
      <v-col justify="center" lg="3"
        ><v-img contain width="450px" src="../../assets/img1.png"
          ><h4><mark>Bierville 1996</mark></h4></v-img
        >
        <p></p>
        <v-img contain width="450px" src="../../assets/img2.png"
          ><h4><mark>Bondy 2019</mark></h4></v-img
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {};
</script>

<style>
mark {
  background-color: white;
  color: black;
}
a:link {
  color: #2b2118;
}
a:visited {
  color: #2b2118;
}
</style>